import { Component } from '@angular/core';

@Component({
  selector: 'brt-header-home-box',
  templateUrl: './header-home-box.component.html',
  styleUrls: ['./header-home-box.component.scss']
})
export class HeaderHomeBoxComponent {

}
